import authReducer from './slices/authSlice';
import dashboardStatsReducer from './slices/dashboardStatsSlice';

export const reducers = {
  auth: authReducer,
  dashboardStatsData: dashboardStatsReducer,
};
